import { text } from '@modules/forgot-password/text';
import { useAuthActions } from '@convex-dev/auth/react';

import { getForgotPasswordVerifyErrorMessage } from '@modules/forgot-password/business_logic';
import { useForgotPasswordStore } from '@shared/store/useForgotPasswordStore';

export function useForgotPasswordVerify(
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  onSuccessNavigate: () => void
) {
  const { signIn } = useAuthActions();
  const form = useForgotPasswordStore((s) => s.form);
  const setIsSubmitting = useForgotPasswordStore((s) => s.setIsSubmitting);
  const reset = useForgotPasswordStore((s) => s.reset);

  return () => {
    if (!form.email || !form.code || !form.newPassword) return;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('code', form.code);
    formData.append('newPassword', form.newPassword);
    formData.append('flow', 'reset-verification');

    signIn('password', formData)
      .then(() => {
        onSuccess(text.verifySuccess);
        setIsSubmitting(false);
        reset();
        onSuccessNavigate();
      })
      .catch((error: Error) => {
        onError(getForgotPasswordVerifyErrorMessage(error));
        setIsSubmitting(false);
      });
  };
}
